import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  div__root: props => ({
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginLeft: '18px',
      filter: props.disabled ? 'contrast(0.5)' : 'unset',
    },
    '& i': {
      marginRight: '9px',
    },
  }),
});
